import { useEffect } from 'react';
import { t } from 'ttag';
import { generatePath, useLocation } from 'react-router-dom';

import { Grid } from '@components/Grid';
import { Product, ProductCard } from '@components/ProductCard';
import { setOpenedTopToStorage, setProductReferrerPathnameToStorage } from '@utils/common';
import { Link } from '@ui/Link';
import { secondaryPage } from '@urls';
import { sendAdsEvent } from '@utils/analytics';
import { useFlags } from '@hook/useFlags';
import { useAppContext } from '@contexts/AppContext';

import s from './TopProducts.sss';

type TopProductsProps = {
  products: Product[];
  showHelpLink?: boolean;
  className?: string
};

export const TopProducts: React.FC<TopProductsProps> = ({
  products,
  showHelpLink = true,
  className,
}) => {
  const location = useLocation();

  const { isOutlet } = useAppContext();
  const flags = useFlags();

  useEffect(() => {
    sendAdsEvent({
      eventType: 'show_promoted_products',
      promotionType: 'top',
    });
  }, []);

  const productsComponents = products.map((p) => (
    <Grid
      key={p.id}
      desktop={3}
      tablet={4}
      def={6}
    >
      <ProductCard
        {...p}
        onProductClick={() => {
          sendAdsEvent({
            eventType: 'view_promoted_products',
            promotionType: 'top',
          });
          setOpenedTopToStorage(p.id);
          setProductReferrerPathnameToStorage({
            productId: p.id,
            pathname: location.pathname,
          });
        }}
        url={`${p.url}?from-adv=true`}
      />
    </Grid>
  ));

  if (isOutlet) {
    return productsComponents;
  }

  if ((showHelpLink && products.length === 4) || !flags.SHAF18704NewTopProductsAlgorithm) {
    return (
      <div className={className}>
        <Grid container={true} spacing={10} className={s.grid}>
          {productsComponents}
        </Grid>
        <div className={s.adHowTo}>
          {t`Реклама на Шафі.`}
          {' '}
          <Link
            to={generatePath(secondaryPage, { slug: 'yak-prosuvaty-svoe-ogoloshennia' })}
          >
            {t`Як сюди потрапити?`}
          </Link>
        </div>
      </div>
    );
  }

  return productsComponents;
};
